import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AnnouncementBox = (props) => {
  const history = useHistory();

  const { statusCount, startDate, endDate } = props;

  let pendingRequest = statusCount?.length > 0 && statusCount.filter((item) => item.approval_status === "Pending")[0];

  const handleCardClick = (item) => {
    history.push({
      pathname: "/approver_pay_request_overview",
      state: { status: item.approval_status, startDate: startDate, endDate: endDate },
    });
  };

  return (
    <div className="widget announcements">
      <div className="widget-header announcements-header">
        <h3>Announcements</h3>
      </div>
      <div className="widget-content">
        <div className="announcement-item">
          <p>
            {`You have ${pendingRequest?.task_count || 0} pending pay requests submitted. Please approve/reject/review
                            them now. `}

            <span className="announcement-link" onClick={() => handleCardClick(pendingRequest)}>
              Click here for more info.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBox;
